<template>
   <canvas id="renderCanvas" @wheel="$event.preventDefault();">
        <slot/>
    </canvas> 
</template>

<style>
    #renderCanvas{
        transition: 1s filter ease;
        outline: none;
    }
    .render-level *{
        box-sizing: content-box !important;
    }
</style>

<script>
    import * as BABYLON from 'babylonjs';
    import { mapGetters,mapMutations} from 'vuex'
    import { Prefab } from "@/store/flux360/PrefabDataTypes";
    
    export default {
        computed: {
            ...mapGetters(['currentSituation']),

            // checks if currentSituation contains panorama video and if so checks if neccessary video data is loaded 
            // needed to display mediaController UI properly
            isVideoPanorama(){
                //Check if currentSituation contains panorama video if not return false
                return this.currentSituation ? this.currentSituation.getType() == Prefab.PrefabType.SituationVideo: false;
            }
        },
        methods: {
            ...mapMutations(["setLoadingscreenVisible"]), //needed for Loadingscreen

            initialize() {
                console.log("Initializing Engine");
                window.engine = new BABYLON.Engine(document.getElementById("renderCanvas"), true, { stencil: true, xrCompatible: false });
                window.engine.setHardwareScalingLevel(1 / window.devicePixelRatio);

                function customLoadingScreen() {}
                customLoadingScreen.prototype.displayLoadingUI = () => {
                    //document.getElementsByClassName("ls-text")[0].innerHTML = "0%"; 
                    this.setLoadingscreenVisible(true);
                };
                customLoadingScreen.prototype.hideLoadingUI = () => {
                    this.setLoadingscreenVisible(false);        
                };
                customLoadingScreen.prototype.setLoadingUIText = (text) => {
                    //document.getElementsByClassName("ls-text")[0].innerHTML = text;       
                }
                window.engine.loadingScreen = new customLoadingScreen();

                const resizeObserver = new ResizeObserver(() => { setTimeout(() => { window.engine.resize(); },0);});
                resizeObserver.observe(document.getElementById("renderCanvas"));
            }
        },
        mounted: function() {
            console.log("Mounted Engine");
            this.$nextTick( () => {
                this.initialize();
            })
        }
    }
</script>